import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "product-details-accordion-fit" }
const _hoisted_2 = {
  key: 0,
  class: "product-details-accordion-fit__card"
}
const _hoisted_3 = ["src", "alt"]
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = {
  key: 1,
  class: "product-details-accordion-fit__card"
}
const _hoisted_6 = ["src", "alt"]
const _hoisted_7 = ["innerHTML"]

import { computed, inject } from 'vue';

import { toLitiumMediaUrlKey } from '@distancify/drapejs-litium/lib/keys';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProductDetailsAccordionFit',
  setup(__props) {

const toLitiumMediaUrl = inject(toLitiumMediaUrlKey);
const product = inject('product') as any;

const fitImage = computed(() => getImage(product.value?.fitInfo?.imageId));

const fitLabel = computed(() => product.value?.fitInfo?.label);

const fitDescription = computed(() =>
  insertLabel(fitLabel.value, product.value?.fitInfo?.description)
);

const shapeFlagImage = computed(() =>
  getImage(product.value?.shapeInfo?.imageId)
);

const shapeFlagLabel = computed(() => product.value?.shapeInfo?.label);

const shapeFlagDescription = computed(() =>
  insertLabel(shapeFlagLabel.value, product.value?.shapeInfo?.description)
);

function getImage(id: string) {
  if (!id) return '';
  return toLitiumMediaUrl?.(id, { maxHeight: 80 });
}

function insertLabel(label: string, description: string) {
  return description?.replace('<p>', `<p><strong>${label}: </strong>`);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(fitDescription) && _unref(fitImage))
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("img", {
            class: "product-details-accordion-fit__card-image",
            src: _unref(fitImage),
            alt: _unref(fitLabel)
          }, null, 8, _hoisted_3),
          _createElementVNode("div", {
            class: "product-details-accordion-fit__card-text",
            innerHTML: _unref(fitDescription)
          }, null, 8, _hoisted_4)
        ]))
      : _createCommentVNode("", true),
    (_unref(shapeFlagDescription) && _unref(shapeFlagImage))
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("img", {
            class: "product-details-accordion-fit__card-image",
            src: _unref(shapeFlagImage),
            alt: _unref(shapeFlagLabel)
          }, null, 8, _hoisted_6),
          _createElementVNode("div", {
            class: "product-details-accordion-fit__card-text",
            innerHTML: _unref(shapeFlagDescription)
          }, null, 8, _hoisted_7)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})